export default __webpack_public_path__ + "static/media/Tarim's Emblem of Sanctity.ea407bdf.jpg";